import { Link } from 'react-router-dom';
import { categories } from '@/mocks/siteData';

interface Crumb {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
  categorySlug?: string;
}

export default function Breadcrumb({ items, categorySlug }: BreadcrumbProps) {
  const categoryLabel = categorySlug
    ? categories.find((c) => c.slug === categorySlug)?.name
    : '';

  return (
    <nav aria-label="Breadcrumb" className="w-full px-4 md:px-6 py-3">
      <ol className="flex items-center flex-wrap gap-1 text-sm text-foreground-600">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          const label = item.label === '__CATEGORY__' ? categoryLabel : item.label;

          return (
            <li key={index} className="flex items-center gap-1">
              {index > 0 && (
                <i className="ri-arrow-right-s-line text-xs text-foreground-400"></i>
              )}
              {!isLast && item.href ? (
                <Link
                  to={item.href}
                  className="hover:text-accent-600 transition-colors whitespace-nowrap"
                >
                  {label}
                </Link>
              ) : (
                <span className={isLast ? 'text-foreground-900 font-medium' : ''}>
                  {label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}